export const SCOPED_ID_PREFIX_KEY = 'scopedIdPrefix';
export const STORE_NAMESPACE_KEY = 'storeNamespace';

/**
 * A reference to the top-level wizard component.
 */
export const WIZARD = 'wizard';
